import { MedRoundDto } from "../../../dto/Dtos";
import { FormElementController, FormElementValidator, FormPageValidator, ValidationResult, FormElementStatus, IValidatingObject } from "../../../scripts/formcontrols";
import moment from 'moment'
import Formatter from "../../corecontrols/formatters/Formatter";

export class RoundItemController extends FormPageValidator {

    public Status: string;
    public Name: FormElementController<string>;
    public Time: FormElementController<string>;
    public HexColour: FormElementController<string>;
    public Dosage: FormElementController<string>

    public get TimeTyped(): Date {
        return moment(this.Time.value, "hh:mm").toDate();
    }

    public GetItem(): MedRoundDto{
        var dto = new MedRoundDto();
        dto.colourHex = this.HexColour.value;
        dto.roundTime = moment(this.Time.value, "HH:mm").format("HH:mm");
        dto.dosage = this.Dosage.value.toString();
        dto.displayTextRound = this.Name.value;
        return dto;
    }

    constructor(parent: RoundSelectorController, status: string, name: string, time: Date, hexColour: string, dosage: string) {
        super("RoundItemController")
        var that = this;
        this.Status = status;

        var nameValidator = new FormElementValidator(false, (d) => {
            if (!d) {
                return new ValidationResult(FormElementStatus.Error, "Name is mandatory");
            }

            if (parent.Rounds.filter(r => r != this).some(r => r.Name.value == d)) {
                return new ValidationResult(FormElementStatus.Error, "Name cannot be Duplicated");
            }

            return new ValidationResult(FormElementStatus.Success, "");
        });


        var timeValidator = new FormElementValidator(true, (d) => {
                if (!moment(d, "HH:mm", true).isValid()) {
                    return new ValidationResult(FormElementStatus.Error, "Enter time in HH:MM 24 Hrs Format");
                }
                return new ValidationResult(FormElementStatus.Success, "Success");
        },
        (d: string) => {
            var isSame = (a: string, b: string) => moment(a, "HH:mm").format('HH:mm') === moment(b, "HH:mm").format('HH:mm');
            var matches = parent.Rounds.filter(r => r != that).filter(r => isSame(r.Time.value, d));
            var hasDuplicate = matches.length > 0;

            if (hasDuplicate) {
                return new ValidationResult(FormElementStatus.Error, "Duplicate Time in round");
            }

            return new ValidationResult(FormElementStatus.Success, "");

        })

        var colourValidator = new FormElementValidator(false, (d) => {
            if (!d) {
                return new ValidationResult(FormElementStatus.Error, "Round Colour is mandatory");
            }
            return new ValidationResult(FormElementStatus.Success, "")
        },
            (d) => {
                if (parent.Rounds.filter(r => r != that).filter(r => r.HexColour.value == d).length > 0) {

                    //console.log("Returing colour error")
                    return new ValidationResult(FormElementStatus.Error, "Duplicate Round Colour");
                }
                return new ValidationResult(FormElementStatus.Success, "")
            }
        );
        var dosageValidator = new FormElementValidator(false, (d:string) => {

            if (!d || d.trim().length ==0 || d.trim().replace("0","").length==0 ) {
                return new ValidationResult(FormElementStatus.Warning, "Dosage Missing");
            }

            return new ValidationResult(FormElementStatus.Success, "");

        });


        var timeString = moment(time,"hh:mm:ss").format("HH:mm");


        var realHexColour = Formatter.HexColour(hexColour);
        this.Name = new FormElementController<string>("Round Name", name, nameValidator);
        this.Time = new FormElementController<string>("Time", timeString, timeValidator);
        this.HexColour = new FormElementController<string>("Colour", realHexColour, colourValidator);
        this.Dosage = new FormElementController<string>("Dosage", dosage, dosageValidator);

        this.addValidators(nameValidator, timeValidator, colourValidator, dosageValidator);
    }
}

export default class RoundSelectorController extends FormPageValidator{

    defaultRounds: Array<MedRoundDto>;
    currentRounds: Array<MedRoundDto>;

    public Rounds: Array<RoundItemController> = new Array<RoundItemController>();

    constructor(defaultRounds: Array<MedRoundDto>, currentRounds: Array<MedRoundDto>) {
        super("RoundSelectorController");

        console.log("RoundSelectorController  Const", defaultRounds, currentRounds)
        this.defaultRounds = defaultRounds;
        this.currentRounds = currentRounds;

        for (var dr of this.currentRounds) {
            this.Rounds.push(new RoundItemController(this, "Current", dr.displayTextRound, moment(dr.roundTime, 'HH:mm').toDate(), dr.colourHex, dr.dosage ? dr.dosage : ""));
        }

        for (var dr of this.defaultRounds) {
            if (!this.currentRounds.some(c => c.roundTime == dr.roundTime)) {
                this.Rounds.push(new RoundItemController(this, "Default", dr.displayTextRound, moment(dr.roundTime, 'HH:mm').toDate(), dr.colourHex, ""));
            }
        }
        this.Rounds = this.Rounds.sort((a, b) => a.TimeTyped.getTime() - b.TimeTyped.getTime());

        this.addValidatorsArray(this.Rounds as IValidatingObject[]);

        for (var round of this.Rounds) {
            round.StatusChanged.on((d) => console.log("RoundSelectorController Child Status Changed - "))
        }
    }


    public validate(): boolean {
        console.log("Running Round Selector Valudate")
        var result = super.validate();
        //if (result) {
        //    if (!this.currentRounds.some(r => parseFloat(r.dosage) > 0)) {
        //        this.SetStatus(FormElementStatus.Error, "Some Round should have dosage");
        //        return false;
        //    }
        //}

        return result;
    }

    public Add() {

        var item = new RoundItemController(this, "New", "Round 5", new Date(), "#444444", "0");
        this.addValidator(item as IValidatingObject);
        //
        //this.Rounds.push(item);
        this.Rounds = this.Rounds.sort((a, b) => a.TimeTyped.getTime() - b.TimeTyped.getTime());
    }

    public Remove(item: RoundItemController) {
        if (item.Status == "New") {
            var index = this.Rounds.indexOf(item);
            this.Rounds.splice(index, 1);
            this.removeValidator(item);
            //item.StatusChanged.off(s => this.StatusHandler(s));
        }
        else {
            item.Dosage.value = "0";
        }
    }

    public get Value(): Array<MedRoundDto>{
        return this.Rounds.filter(r => r.Dosage.value.trim().replace("0","").length > 0).map(r => {
            var dto = new MedRoundDto();
            dto.colourHex = r.HexColour.value;
            dto.displayTextRound = r.Name.value;
            dto.dosage = r.Dosage.value.toString();
            dto.roundTime = r.Time.value;
            return dto;
        })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/RoundSelector/RoundSelectorController.ts